import { baseUrl } from "../constants/constants";
import server from "../utils/interceptors/interceptors";
import { getToken } from "../utils/localstorage/token";

const postRequest = async (path, payload) => {
  const AXIOS_CONFIG = {
    headers: {
       "Content-Type": "application/json",
      "Accept": "application/json",
    },
  };
  const API_ENDPOINT = `${baseUrl}${path}`;
  return await server.post(API_ENDPOINT, payload, AXIOS_CONFIG);
};

const postRequestWithToken = async (path, payload) => {
  const USER_TOKEN = getToken(); // Get fresh token for each request
  const AXIOS_CONFIG = {
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      Authorization: USER_TOKEN,
    },
  };
  const API_ENDPOINT = `${baseUrl}${path}`;
  return await server.post(API_ENDPOINT, payload, AXIOS_CONFIG);
};

const postFileRequestWithToken = async (path, payload) => {
  const USER_TOKEN = getToken(); // Get fresh token for each request
  
  const AXIOS_CONFIG = {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept": "multipart/form-data",
      Authorization: USER_TOKEN,
    },
  };
  const API_ENDPOINT = `${baseUrl}${path}`;
  
  return await server.post(API_ENDPOINT, payload, AXIOS_CONFIG);
};

const getRequest = async path => {
  const AXIOS_CONFIG = {
    headers: {
      'Access-Control-Allow-Origin': '*'
    },
  };
  const API_ENDPOINT = `${baseUrl}${path}`;
  return await server.get(API_ENDPOINT, AXIOS_CONFIG);
};

const getRequestWithToken = async path => {
  const USER_TOKEN = getToken(); // Get fresh token for each request
  const AXIOS_CONFIG = {
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      Authorization: USER_TOKEN,
    },
  };
  const API_ENDPOINT = `${baseUrl}${path}`;
  return await server.get(API_ENDPOINT, AXIOS_CONFIG);
};

export {
  postRequest,
  postRequestWithToken,
  postFileRequestWithToken,
  getRequest,
  getRequestWithToken
};
